import useTabState from '../hooks/useTabState';
import PageLayout from '../components/ui/PageLayout';
import TabBar from '../components/ui/TabBar';
import Compliance from './Compliance';
import IAReport from './IAReport';
import SubledgerView from './SubledgerView';
import TaskQueue from './TaskQueue';
import OrgConfigAuditLog from './OrgConfigAuditLog';

const TABS = ['Compliance', 'IA Report', 'Sub-ledger', 'Task Queue', 'Config Audit Log'] as const;
type Tab = typeof TABS[number];

export default function AuditCompliance() {
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'Compliance');

  return (
    <PageLayout title="Audit & Compliance" subtitle="Compliance reporting, internal audit, and system monitoring">
      <TabBar
        tabs={TABS.map(t => ({ key: t, label: t }))}
        active={activeTab}
        onChange={v => setActiveTab(v as Tab)}
      />
      {activeTab === 'Compliance' && <Compliance />}
      {activeTab === 'IA Report' && <IAReport />}
      {activeTab === 'Sub-ledger' && <SubledgerView />}
      {activeTab === 'Task Queue' && <TaskQueue />}
      {activeTab === 'Config Audit Log' && <OrgConfigAuditLog />}
    </PageLayout>
  );
}
